<template>
  <div class="qty-component d-flex justify-content-around">
    <button class="rmv-qty-btn text-white" @click="removeFromCart">
      <font-awesome-icon icon="fa-solid fa-minus"/>
    </button>
    <input class="qty-input" 
           v-model="saleLine.Qty" 
           type="number" 
           :readonly="isReadOnly">
    <button class="add-qty-btn text-white" @click="addToCart" v-if="!saleLine.voucher">
      <font-awesome-icon icon="fa-solid fa-plus"/>
    </button>
  </div>
</template>

<script>
export default {
  name: "CurrentSaleQty",
  props: {
    saleLine: {
      type: Object,
      required: true
    }
  },
  computed : {
    deviceSettings(){
      return this.$store.getters.getDeviceSettings;
    },
    isReadOnly(){
      if (!this.deviceSettings) return true;
      return !this.deviceSettings.SelectQty;
    },
  },
  methods: {
    addToCart() {
      return this.$store.dispatch('getStockSetting', this.saleLine.Plu)
          .then(async (set) => {
            let price = Number(this.saleLine.Unit.toFixed(2));
            let description = this.saleLine.Description;

            if (set.askForPrice){
              price = (await this.askForPrice(this.saleLine));
            }
            if (set.cookingLink) {
               return this.$router.push({
                 name: 'instruction',
                 query: {
                   plu: this.saleLine.Plu
                 }
               })
            }

            let specialPrice = this.$store.getters.getItemSpecialPrice(this.saleLine.Plu)
            if (specialPrice){
              price = specialPrice;
            }

            let tourismLevy = 0.0;
            if (set.tourism){
              let obj = { amount : price, incl : true }
              tourismLevy = await this.$store.dispatch('getTourismLevyAmount', obj);
            }

            let obj = {
              Plu: this.saleLine.Plu,
              Description: description,
              Qty: 1,
              Unit: price,
              Line: price,
              tourismLevy,
              Discount: 0,
              vat: 0,
              instructions: []
            }
            this.$store.commit('addToCurrentSaleLines', obj)
            return this.recalculateTip();
          })
    },

    recalculateTip(){
      return this.$store.dispatch('calculateTipAmount')
    },

    removeFromCart() {
      return this.$store.commit("voidItem", this.saleLine);
    },

    askForPrice(item) {
      return Swal.fire({
        allowOutsideClick: false,
        showCancelButton: true,
        showLoaderOnConfirm: true,
        title: `Set Selling Price`,
        html: `<h6 >Description : ${item.Description}</h6>
               <h6 >Current Price : ${item.Unit.toFixed(2)}</h6>
               <input type="number" step="0.01" id="selling-prc" class="swal2-input" placeholder="Selling Price" style="max-width: 70%">`,
        confirmButtonText: 'Set Price',
        focusConfirm: false,
        preConfirm: async () => {
          let value = Swal.getPopup().querySelector('#selling-prc').value
          if (!value) {
            Swal.showValidationMessage(`Please enter a valid Selling Price`)
          }
          return parseFloat(value);
        }
      }).then(result=>{
        if (result.isConfirmed){
          return result.value;
        }
        return parseFloat(item.SellingIncl.toFixed(2))
      })
    }
  }
}
</script>

<style scoped>
.qty-component {
  gap: 5px;
}

.qty-input {
  width: 90px;
  border: 1px solid #C9CACF;
  border-radius: 10px;
  text-align: center;
  padding: 5px 8px;
  font-size: 16px;
}

.add-qty-btn, .rmv-qty-btn {
  border-radius: 10px;
  width: 30px;
  height: 30px;
}

button {
  background: #0092f7;
}
</style>
